var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("h1", [_vm._v("Bienvenido al Sistema de Recursos Humanos (SAP)")]),
      _vm._v(" "),
      _c(
        "v-container",
        {
          attrs: {
            "fill-height": "",
            fluid: "",
            align: "center",
            justify: "center"
          }
        },
        [
          _c("v-card-text"),
          _c("img", {
            attrs: { src: require("@/assets/images/bg.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("v-card-text")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59acc3d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59acc3d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Dashboard.vue
// module id = null
// module chunks = 